import React, { useState } from 'react';
import { makeStyles, Select, TextField } from "@material-ui/core";
import {epochSeconds, isHidden} from "../utils/Functions";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import BackspaceOutlinedIcon from "@mui/icons-material/BackspaceOutlined";
import FileDownloadDoneOutlinedIcon from '@mui/icons-material/FileDownloadDoneOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import { MenuItem } from "@mui/material";
import {getAccessToken} from "../utils/Auth";
import {toast} from "react-toastify";
import axios from "axios";
import Constants from "../utils/Constants";


// This is a list/table element for Listener options in the AnalyzerDialog


const useStyles = makeStyles(theme => ({
    outer_div: {
        minHeight: '100vh',
    },
    card: {
        backgroundColor: '#424242',
        color: '#EEEEEE',
    },
    itemBar: {
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: '#222222',
    },
    pageBar: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        backgroundColor: '#222222',
        color: '#AAAAAA',
    },
    collapsableTableComponent: {
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '10px',
        borderBottom: '1px solid #ccc'
    },
    tableComponent: {
        borderStyle: 'solid',
        borderColor: '#000',
        borderRadius: '10px',
        borderSpacing: '0px',
        borderRightWidth: '0px',
        borderTopWidth: '1px',
        borderBottomWidth: '0px',
        borderLeftWidth: '0px',
        // backgroundColor: '#222222' // setting this breaks row highlighting
    },
    tableCell: {
        paddingLeft: '12px',
        paddingRight: '12px',
        borderBottom: '1px solid #444',
        color: '#CCCCCC',
    },
    clickableTableCell: {
        paddingLeft: '12px',
        borderBottom: '1px solid #444',
        cursor: 'pointer',
    },
    dialog: {
        backgroundColor: '#333333',
        color: '#CCCCCC',
        margin: '10',
    },
    dialogTitleBar: {
        backgroundColor: '#4e54bf',
        color: '#CCCCCC',
    },
    dialogConfirm: {
        backgroundColor: '#149616',
        color: '#CCCCCC',
    },
    dialogNeutral: {
        backgroundColor: '#4e54bf',
        color: '#CCCCCC',
    },
    dialogWarning: {
        backgroundColor: '#d42842',
        color: '#CCCCCC',
    },
    primaryColor: {
        color: '#000',
        backgroundColor: '#111'
    },
    whiteColor: {
        color: "#EEE",
    },
    hide: {
        display: 'none',
    },
    spaced: {
        margin: '10px',
    }
}))

const toastOptions = {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: false,
    pauseOnHover: true,
    draggable: true
}

export default function Listener({ index, listener, headers, setRequiresSave, handleListenerChange, handleListenerDelete }) {
    const classes = useStyles()
    const [isOpen, setIsOpen] = useState(false);
    const [isSelected, setIsSelected] = useState(false);

    const listener_type_menu = [
        { label: "HTTP", value: "HTTP", disabled: false },
        { label: "Syslog UDP", value: "Syslog UDP", disabled: false },
        { label: "Syslog TCP", value: "Syslog TCP", disabled: false },
        { label: "AWS SQS", value: "AWS SQS", disabled: true },
        { label: "GCP PubSub", value: "GCP PubSub", disabled: true },
    ]

    const toggleOpen = () => {
        console.log(JSON.stringify(listener))
        setIsOpen(!isOpen);
    };

    const setEnabled = (enabled) => {
        listener.enabled = enabled;
        setRequiresSave()
    }

    function getEnabledButton() {
        if (listener.enabled) {
            return (
                <td className={isHidden('collapse', headers) ? classes.hide : classes.clickableTableCell}>
                    <CheckCircleOutlinedIcon color={"success"} onClick={(e) => setEnabled(false)} />
                </td>
            )
        }
        else {
            return (
                <td className={isHidden('collapse', headers) ? classes.hide : classes.clickableTableCell}>
                    <BlockOutlinedIcon color={"error"} onClick={(e) => setEnabled(true)} />
                </td>
            )
        }
    }

    function getRow() {
        let target_label = "none"
        if (listener.listener_type === 'HTTP' || listener.listener_type === 'Syslog UDP' || listener.listener_type === 'Syslog TCP') {
            target_label = listener.ip + ":" + listener.port
        } else {
            target_label = "-"
        }
        if (!isOpen) {
            return (
                <tr
                    key={index} onClick={() => setIsSelected(!isSelected)}
                    className={classes.tableComponent}
                >
                    <td className={isHidden('listener_enabled', headers) ? classes.hide : classes.tableCell}>
                        {getEnabledButton()}
                    </td>
                    <td className={isHidden('listener_type', headers) ? classes.hide : classes.tableCell}>{listener.listener_type}</td>
                    <td className={isHidden('target', headers) ? classes.hide : classes.tableCell}>{target_label}</td>
                    <td className={isHidden('edit', headers) ? classes.hide : classes.clickableTableCell}>
                        <EditOutlinedIcon color={"primary"} onClick={(e) => toggleOpen()}/>
                    </td>
                    <td className={isHidden('delete', headers) ? classes.hide : classes.clickableTableCell}>
                        <BackspaceOutlinedIcon color={"error"}
                                               onClick={(e) => handleListenerDelete(index)}/>
                    </td>
                </tr>
            )
        } else {
            return (
                <tr
                    key={index} onClick={() => setIsSelected(!isSelected)}
                    className={classes.tableComponent}
                >
                    <td className={isHidden('listener_enabled', headers) ? classes.hide : classes.tableCell}>
                        {getEnabledButton()}
                    </td>
                    <td className={isHidden('listener_type', headers) ? classes.hide : classes.tableCell}>
                        <Select
                            id="listener_type"
                            label="Type"
                            name="listener_type"
                            variant={"outlined"}
                            value={listener.listener_type}
                            onChange={(e) => {
                                console.log("event: " + Object.keys(e));
                                handleListenerChange(index, e);
                            }}
                            classes={{root: classes.whiteColor, icon: classes.whiteColor}}
                            style={{minWidth: 100}}
                        >
                            {listener_type_menu.map((item) =>
                                <MenuItem key={item.value} value={item.value}
                                          disabled={item.disabled}>{item.label}</MenuItem>)}
                        </Select>
                    </td>
                    <td className={isHidden('target', headers) ? classes.hide : classes.tableCell}>{target_label}</td>
                    <td className={isHidden('edit', headers) ? classes.hide : classes.clickableTableCell}>
                        <EditOutlinedIcon color={"primary"} onClick={(e) => toggleOpen()}/>
                    </td>
                    <td className={isHidden('delete', headers) ? classes.hide : classes.clickableTableCell}>
                        <BackspaceOutlinedIcon color={"error"}
                                               onClick={(e) => handleListenerDelete(index)}/>
                    </td>
                </tr>
            )
        }
    }

    function getDetail() {
        if (listener.listener_type === "HTTP" || listener.listener_type === "Syslog UDP" || listener.listener_type === "Syslog TCP") {
            return (
                <>
                    <tr>
                        <td></td>
                        <td style={{width: "150px"}}>IP</td>
                        <td style={{width: "400px"}}>
                            <TextField
                                id="ip"
                                label="IP"
                                name="ip"
                                variant={"outlined"}
                                type="text"
                                inputProps={{style: {color: 'lightgray'}}}
                                InputLabelProps={{style: {color: 'lightgray'}}}
                                value={listener.ip}
                                onChange={(e) => {
                                    handleListenerChange(index, e);
                                }}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td style={{width: "150px"}}>Port</td>
                        <td style={{width: "400px"}}>
                            <TextField
                                id="port"
                                label="Port"
                                name="port"
                                variant={"outlined"}
                                type="text"
                                inputProps={{style: {color: 'lightgray'}}}
                                InputLabelProps={{style: {color: 'lightgray'}}}
                                value={listener.port}
                                onChange={(e) => {
                                    handleListenerChange(index, e);
                                }}
                            />
                        </td>
                    </tr>
                </>
            )
        }
        else {
            return (
                <></>
            )
        }
    }

    return (
        <>
            {getRow()}
            {isOpen && getDetail()}
        </>
    )
}

